import React from 'react';
import {Route} from 'react-router-dom';
import {AUTH_GET_PERMISSIONS} from 'admin-on-rest';
import authClient from './authClient';
import {resolveAccess} from './Fuse/shared/authFunctions';

import {CombinedSalesReports} from './Fuse/Report/CombinedSalesReports';
import {CreditCardTransactionReports} from './Fuse/Report/CreditCardTransactionReports';
import {DailySalesReports} from './Fuse/Report/DailySalesReports';
import {DetailedSalesReports} from './Fuse/Report/DetailedSalesReports';
import {DiscountsReports} from './Fuse/Report/DiscountsReports';
import {InventoryLogReports} from './Fuse/Report/InventoryLogReports';
import {InventoryTransferLookupReports} from './Fuse/Report/InventoryTransferLookupReports';
import {ItemSalesReports} from './Fuse/Report/ItemSalesReports';
import {LocationRegisterLogReports} from './Fuse/Report/LocationRegisterLogReports';
import {PreSettlementReports} from './Fuse/Report/PreSettlementReports';
import {SalesComparisonReports} from './Fuse/Report/SalesComparisonReports';
import {SalesLogReports} from './Fuse/Report/SalesLogReports';
import {SalesSummaryReports} from './Fuse/Report/SalesSummaryReports';
import {SalesTaxAuditReports} from './Fuse/Report/SalesTaxAuditReports';
import {SettlementReports} from './Fuse/Report/SettlementReports';
import {TransactionLogReports} from './Fuse/Report/TransactionLogReports';
import {VIPSignupsReports} from './Fuse/Report/VIPSignupsReports';
import {VIPTrendsReports} from './Fuse/Report/VIPTrendsReports';

import {InventoryOrders} from './Fuse/views/InventoryOrders';
import InventoryOrderDetail from './Fuse/components/InventoryOrderDetail';
import {ReportJobs} from './Fuse/views/ReportJobs';
import {ReportJobBuilder} from './Fuse/views/ReportJobBuilder';
import {CreateReportJob} from './Fuse/views/CreateReportJob';
import {ScheduledReports} from './Fuse/views/ScheduledReports';
import {ScheduleReport} from './Fuse/views/ScheduleReport';
import NoAccess from './Fuse/noAccess';

/**
 * Route for returning an allowed path or No Access
 *
 * @param Component
 * @param path
 * @param exact
 * @param rest
 * @return {*}
 * @constructor
 */
const ReportsRoute = ({component: Component, path, exact, ...rest}) => (
    resolveAccess(authClient(AUTH_GET_PERMISSIONS))
        ? <Route exact={exact} path={path} {...rest} render={routeProps => (<Component {...routeProps}/>)}/>
        : <Route exact={exact} path="/NoAccess" component={NoAccess}/>
);

export default [
    <ReportsRoute exact path="/CombinedSalesReports" component={CombinedSalesReports}/>,
    <ReportsRoute exact path="/CreditCardTransactionReports" component={CreditCardTransactionReports}/>,
    <ReportsRoute exact path="/DailySalesReports" component={DailySalesReports}/>,
    <ReportsRoute exact path="/DetailedSalesReports" component={DetailedSalesReports}/>,
    <ReportsRoute exact path="/DiscountsReports" component={DiscountsReports}/>,
    <ReportsRoute exact path="/InventoryLogReports" component={InventoryLogReports}/>,
    <ReportsRoute exact path="/InventoryTransferLookupReports" component={InventoryTransferLookupReports}/>,
    <ReportsRoute exact path="/ItemSalesReports" component={ItemSalesReports}/>,
    <ReportsRoute exact path="/LocationRegisterLogReports" component={LocationRegisterLogReports}/>,
    <ReportsRoute exact path="/PreSettlementReports" component={PreSettlementReports}/>,
    <ReportsRoute exact path="/SalesComparisonReports" component={SalesComparisonReports}/>,
    <ReportsRoute exact path="/SalesLogReports" component={SalesLogReports}/>,
    <ReportsRoute exact path="/SalesSummaryReports" component={SalesSummaryReports}/>,
    <ReportsRoute exact path="/SalesTaxAuditReports" component={SalesTaxAuditReports}/>,
    <ReportsRoute exact path="/SettlementReports" component={SettlementReports}/>,
    <ReportsRoute exact path="/TransactionLogReports" component={TransactionLogReports}/>,
    <ReportsRoute exact path="/VIPSignupsReports" component={VIPSignupsReports}/>,
    <ReportsRoute exact path="/VIPTrendsReports" component={VIPTrendsReports}/>,
    <ReportsRoute exact path="/ReportJobs" component={ReportJobs}/>,
    <ReportsRoute exact path="/CreateReportJob" component={CreateReportJob}/>,
    <ReportsRoute exact path="/ScheduledReports" component={ScheduledReports}/>,
    <ReportsRoute exact path="/ScheduleReport" component={ScheduleReport}/>,
    <ReportsRoute exact path="/JobBuilder" component={ReportJobBuilder}/>,
    <ReportsRoute exact path="/InventoryOrder/:job_id/:location_id" component={InventoryOrderDetail}/>,
    <ReportsRoute exact path="/InventoryOrders" component={InventoryOrders}/>,
    <Route exact path="/NoAccess" component={NoAccess}/>
];



// WEBPACK FOOTER //
// ./src/routes.js